var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activity.footer && _vm.activity.footer.length > 10)?_c('div',{staticClass:"external-activity--footer",domProps:{"innerHTML":_vm._s(_vm.activity.footer)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }